<template>
    <form action="/subscribe-confirm" method="POST" id="payment-form">

      <input type="hidden" name="plan" :value="plan">

      
      <h3>Thanks!</h3> 
      <p>Before we complete your subscription, please confirm your country:</p>


  <div class="form-group">
    <label for="select_country">Country</label>
          <select id="select_country" name="country" v-model="selected_country" class="form-control w-100">
        <option v-for="(country, code) in countries" :value="code" :selected="(detected == code)">{{ country }}</option>
      </select>
  </div>




      <div v-if="(eu.includes(selected_country))">
          
          <p>Are you registed for VAT?</p>

          <div class="form-group">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="vatregistered" id="vatRegisteredYes" v-model.number="vatRegistered" :value="true">
              <label class="form-check-label" for="vatRegisteredYes">Yes</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="vatregistered" id="vatRegisteredNo" v-model.number="vatRegistered" :value="false">
              <label class="form-check-label" for="vatRegisteredNo">No</label>
            </div>
          </div>

          <div v-if="vatRegistered">
            <p>Please enter your VAT number:</p>
            <div class="form-group">
                <label for="vatNumber">VAT Number</label>
                <input type="text" class="form-control" id="vatNumber" name="vatnumber" :placeholder="'VAT Number including Country Code, eg. '+selected_country+'1234567'">
            </div>
          </div>

      </div>


      <!-- CSRF Field -->
      <input type="hidden" name="_token" :value="csrf">

      <div class="spacer"></div>

      <button id="card-button" class="btn btn-primary btn-block btn-lg" >
          Complete Signup
      </button>

    

  </form>
</template>

<script>
    
import Noty from 'noty';



    export default {
        props: [
            'plan',
            'detected',
        ],
        mounted(){

          var vm = this;

          axios.get('/billing/list-plans/').then(response => {

            vm.plans = response.data;

            vm.selected_plan = response.data[0];


          }).catch(function(error){ vm.handleError(error) });




        },
        data () {
            return {
              csrf: document.head.querySelector('meta[name="csrf-token"]').content,
              selected_country: this.detected,
              vatRegistered: false,
              countries: {
                'GB' : "United Kingdom", 
                'US' : "United States of America", 
                'AF' : "Afghanistan", 
                'AX' : "Aland Islands", 
                'AL' : "Albania", 
                'DZ' : "Algeria", 
                'AS' : "American Samoa", 
                'AD' : "Andorra", 
                'AO' : "Angola", 
                'AI' : "Anguilla", 
                'AQ' : "Antarctica", 
                'AG' : "Antigua and Barbuda", 
                'AR' : "Argentina", 
                'AM' : "Armenia", 
                'AW' : "Aruba", 
                'AU' : "Australia", 
                'AT' : "Austria", 
                'AZ' : "Azerbaijan", 
                'BS' : "Bahamas", 
                'BH' : "Bahrain", 
                'BD' : "Bangladesh", 
                'BB' : "Barbados", 
                'BY' : "Belarus", 
                'BE' : "Belgium", 
                'BZ' : "Belize", 
                'BJ' : "Benin", 
                'BM' : "Bermuda", 
                'BT' : "Bhutan", 
                'BO' : "Bolivia", 
                'BA' : "Bosnia and Herzegovina", 
                'BW' : "Botswana", 
                'BV' : "Bouvet Island", 
                'BR' : "Brazil", 
                'VG' : "British Virgin Islands", 
                'IO' : "British Indian Ocean Territory", 
                'BN' : "Brunei Darussalam", 
                'BG' : "Bulgaria", 
                'BF' : "Burkina Faso", 
                'BI' : "Burundi", 
                'KH' : "Cambodia", 
                'CM' : "Cameroon", 
                'CA' : "Canada", 
                'CV' : "Cape Verde", 
                'KY' : "Cayman Islands", 
                'CF' : "Central African Republic", 
                'TD' : "Chad", 
                'CL' : "Chile", 
                'CN' : "China", 
                'HK' : "Hong Kong, SAR China", 
                'MO' : "Macao, SAR China", 
                'CX' : "Christmas Island", 
                'CC' : "Cocos (Keeling) Islands", 
                'CO' : "Colombia", 
                'KM' : "Comoros", 
                'CG' : "Congo (Brazzaville)", 
                'CD' : "Congo, (Kinshasa)", 
                'CK' : "Cook Islands", 
                'CR' : "Costa Rica", 
                'CI' : "Côte d'Ivoire", 
                'HR' : "Croatia", 
                'CU' : "Cuba", 
                'CY' : "Cyprus", 
                'CZ' : "Czech Republic", 
                'DK' : "Denmark", 
                'DJ' : "Djibouti", 
                'DM' : "Dominica", 
                'DO' : "Dominican Republic", 
                'EC' : "Ecuador", 
                'EG' : "Egypt", 
                'SV' : "El Salvador", 
                'GQ' : "Equatorial Guinea", 
                'ER' : "Eritrea", 
                'EE' : "Estonia", 
                'ET' : "Ethiopia", 
                'FK' : "Falkland Islands (Malvinas)", 
                'FO' : "Faroe Islands", 
                'FJ' : "Fiji", 
                'FI' : "Finland", 
                'FR' : "France", 
                'GF' : "French Guiana", 
                'PF' : "French Polynesia", 
                'TF' : "French Southern Territories", 
                'GA' : "Gabon", 
                'GM' : "Gambia", 
                'GE' : "Georgia", 
                'DE' : "Germany", 
                'GH' : "Ghana", 
                'GI' : "Gibraltar", 
                'GR' : "Greece", 
                'GL' : "Greenland", 
                'GD' : "Grenada", 
                'GP' : "Guadeloupe", 
                'GU' : "Guam", 
                'GT' : "Guatemala", 
                'GG' : "Guernsey", 
                'GN' : "Guinea", 
                'GW' : "Guinea-Bissau", 
                'GY' : "Guyana", 
                'HT' : "Haiti", 
                'HM' : "Heard and Mcdonald Islands", 
                'VA' : "Holy See (Vatican City State)", 
                'HN' : "Honduras", 
                'HU' : "Hungary", 
                'IS' : "Iceland", 
                'IN' : "India", 
                'ID' : "Indonesia", 
                'IR' : "Iran, Islamic Republic of", 
                'IQ' : "Iraq", 
                'IE' : "Ireland", 
                'IM' : "Isle of Man", 
                'IL' : "Israel", 
                'IT' : "Italy", 
                'JM' : "Jamaica", 
                'JP' : "Japan", 
                'JE' : "Jersey", 
                'JO' : "Jordan", 
                'KZ' : "Kazakhstan", 
                'KE' : "Kenya", 
                'KI' : "Kiribati", 
                'KP' : "Korea (North)", 
                'KR' : "Korea (South)", 
                'KW' : "Kuwait", 
                'KG' : "Kyrgyzstan", 
                'LA' : "Lao PDR", 
                'LV' : "Latvia", 
                'LB' : "Lebanon", 
                'LS' : "Lesotho", 
                'LR' : "Liberia", 
                'LY' : "Libya", 
                'LI' : "Liechtenstein", 
                'LT' : "Lithuania", 
                'LU' : "Luxembourg", 
                'MK' : "Macedonia, Republic of", 
                'MG' : "Madagascar", 
                'MW' : "Malawi", 
                'MY' : "Malaysia", 
                'MV' : "Maldives", 
                'ML' : "Mali", 
                'MT' : "Malta", 
                'MH' : "Marshall Islands", 
                'MQ' : "Martinique", 
                'MR' : "Mauritania", 
                'MU' : "Mauritius", 
                'YT' : "Mayotte", 
                'MX' : "Mexico", 
                'FM' : "Micronesia, Federated States of", 
                'MD' : "Moldova", 
                'MC' : "Monaco", 
                'MN' : "Mongolia", 
                'ME' : "Montenegro", 
                'MS' : "Montserrat", 
                'MA' : "Morocco", 
                'MZ' : "Mozambique", 
                'MM' : "Myanmar", 
                'NA' : "Namibia", 
                'NR' : "Nauru", 
                'NP' : "Nepal", 
                'NL' : "Netherlands", 
                'AN' : "Netherlands Antilles", 
                'NC' : "New Caledonia", 
                'NZ' : "New Zealand", 
                'NI' : "Nicaragua", 
                'NE' : "Niger", 
                'NG' : "Nigeria", 
                'NU' : "Niue", 
                'NF' : "Norfolk Island", 
                'MP' : "Northern Mariana Islands", 
                'NO' : "Norway", 
                'OM' : "Oman", 
                'PK' : "Pakistan", 
                'PW' : "Palau", 
                'PS' : "Palestinian Territory", 
                'PA' : "Panama", 
                'PG' : "Papua New Guinea", 
                'PY' : "Paraguay", 
                'PE' : "Peru", 
                'PH' : "Philippines", 
                'PN' : "Pitcairn", 
                'PL' : "Poland", 
                'PT' : "Portugal", 
                'PR' : "Puerto Rico", 
                'QA' : "Qatar", 
                'RE' : "Réunion", 
                'RO' : "Romania", 
                'RU' : "Russian Federation", 
                'RW' : "Rwanda", 
                'BL' : "Saint-Barthélemy", 
                'SH' : "Saint Helena", 
                'KN' : "Saint Kitts and Nevis", 
                'LC' : "Saint Lucia", 
                'MF' : "Saint-Martin (French part)", 
                'PM' : "Saint Pierre and Miquelon", 
                'VC' : "Saint Vincent and Grenadines", 
                'WS' : "Samoa", 
                'SM' : "San Marino", 
                'ST' : "Sao Tome and Principe", 
                'SA' : "Saudi Arabia", 
                'SN' : "Senegal", 
                'RS' : "Serbia", 
                'SC' : "Seychelles", 
                'SL' : "Sierra Leone", 
                'SG' : "Singapore", 
                'SK' : "Slovakia", 
                'SI' : "Slovenia", 
                'SB' : "Solomon Islands", 
                'SO' : "Somalia", 
                'ZA' : "South Africa", 
                'GS' : "South Georgia and the South Sandwich Islands", 
                'SS' : "South Sudan", 
                'ES' : "Spain", 
                'LK' : "Sri Lanka", 
                'SD' : "Sudan", 
                'SR' : "Suriname", 
                'SJ' : "Svalbard and Jan Mayen Islands", 
                'SZ' : "Swaziland", 
                'SE' : "Sweden", 
                'CH' : "Switzerland", 
                'SY' : "Syrian Arab Republic (Syria)", 
                'TW' : "Taiwan, Republic of China", 
                'TJ' : "Tajikistan", 
                'TZ' : "Tanzania, United Republic of", 
                'TH' : "Thailand", 
                'TL' : "Timor-Leste", 
                'TG' : "Togo", 
                'TK' : "Tokelau", 
                'TO' : "Tonga", 
                'TT' : "Trinidad and Tobago", 
                'TN' : "Tunisia", 
                'TR' : "Turkey", 
                'TM' : "Turkmenistan", 
                'TC' : "Turks and Caicos Islands", 
                'TV' : "Tuvalu", 
                'UG' : "Uganda", 
                'UA' : "Ukraine", 
                'AE' : "United Arab Emirates", 
                'UM' : "US Minor Outlying Islands", 
                'UY' : "Uruguay", 
                'UZ' : "Uzbekistan", 
                'VU' : "Vanuatu", 
                'VE' : "Venezuela (Bolivarian Republic)", 
                'VN' : "Viet Nam", 
                'VI' : "Virgin Islands, US", 
                'WF' : "Wallis and Futuna Islands", 
                'EH' : "Western Sahara", 
                'YE' : "Yemen", 
                'ZM' : "Zambia", 
                'ZW' : "Zimbabwe"
              },
              eu: ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HU', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK']
            }
        },
        methods: {
            updateSelected: function(){

              console.log(this.$refs.plan.value);
              console.log(this.plans[0]['id']);

              this.selected_plan = this.plans.find(plan => plan.id == this.$refs.plan.value);

            },

      }
    }
</script>